<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                hide-details
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                outlined
                hide-details
                label="แผนก"
                class="ma-2"
              ></v-select>
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-icon color="#871B12" size="30" @click="saerchDataAdvanced()"
                >mdi-calendar-search</v-icon
              >
              <v-icon color="#871B12" size="30" @click="clear()"
                >mdi-refresh</v-icon
              >
            </v-sheet>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="ma-2 white--text"
              @click="exportReport()"
            >
              Download
              <v-icon right dark> mdi-cloud-download </v-icon>
            </v-btn>
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="ma-2 white--text"
              @click="getData()"
            >
              reload
              <v-icon right dark> mdi-reload </v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="searchAll"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <!-- data table -->

          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
                 <v-dialog v-model="dialogView" persistent max-width="80%">
                    <v-card>
                      <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialogView = false">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title
                        >ข้อมูลพนักงานลา <br>
                        [{{empCode}} {{empFull_NameTH}}]
                        [{{masDepartmentName}}] [{{masBranchName}}] [{{masCompanyName}}]</v-toolbar-title
                        >
                      </v-toolbar>
                      <v-card-title>
                        <v-text-field
                          v-model="searchInfoByMonth"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <v-data-table
                            :headers="columnsSelect"
                            :items="dataItemByMonth"
                            :search="searchInfoByMonth"
                            :items-per-page="10"
                          >
                          </v-data-table>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          elevation="2"
                          x-large
                          color="dark darken-1"
                          text
                          @click="dialogView = false"
                        >
                          <v-icon left> mdi-cancel</v-icon>
                          ปิด
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll"
                  :items-per-page="500"
                >
                  <template v-slot:[`item.JAN`]="{ item }">
                    <v-chip
                      class="ma-2"
                      :color="item.JAN_COLOR"
                      @click.stop="dialogView = true, getDataShift(item, 1)"
                    >
                      {{ item.JAN + 0.0 }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.FEB`]="{ item }">
                    <v-chip
                      class="ma-2"
                      :color="item.FEB_COLOR"
                      @click.stop="dialogView = true, getDataShift(item, 2)"
                    >
                      {{ item.FEB + 0.0 }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.MAR`]="{ item }">
                    <v-chip
                      class="ma-2"
                      :color="item.MAR_COLOR"
                      @click.stop="dialogView = true, getDataShift(item, 3)"
                    >
                      {{ item.MAR + 0.0 }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.APR`]="{ item }">
                    <v-chip
                      class="ma-2"
                      :color="item.APR_COLOR"
                      @click.stop="dialogView = true, getDataShift(item, 4)"
                    >
                      {{ item.APR + 0.0 }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.MAY`]="{ item }">
                    <v-chip
                      class="ma-2"
                      :color="item.MAY_COLOR"
                      @click.stop="dialogView = true, getDataShift(item, 5)"
                    >
                      {{ item.MAY + 0.0 }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.JUN`]="{ item }">
                    <v-chip
                      class="ma-2"
                      :color="item.JUN_COLOR"
                      @click.stop="dialogView = true, getDataShift(item, 6)"
                    >
                      {{ item.JUN + 0.0 }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.JUL`]="{ item }">
                    <v-chip
                      class="ma-2"
                      :color="item.JUL_COLOR"
                      @click.stop="dialogView = true, getDataShift(item, 7)"
                    >
                      {{ item.JUL + 0.0 }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.AUG`]="{ item }">
                    <v-chip
                      class="ma-2"
                      :color="item.AUG_COLOR"
                      @click.stop="dialogView = true, getDataShift(item, 8)"
                    >
                      {{ item.AUG + 0.0 }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.SEP`]="{ item }">
                    <v-chip
                      class="ma-2"
                      :color="item.SEP_COLOR"
                      @click.stop="dialogView = true, getDataShift(item, 9)"
                    >
                      {{ item.SEP + 0.0 }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.OCT`]="{ item }">
                    <v-chip
                      class="ma-2"
                      :color="item.OCT_COLOR"
                      @click.stop="dialogView = true, getDataShift(item, 10)"
                    >
                      {{ item.OCT + 0.0 }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.NOV`]="{ item }">
                    <v-chip
                      class="ma-2"
                      :color="item.NOV_COLOR"
                      @click.stop="dialogView = true, getDataShift(item, 11)"
                    >
                      {{ item.NOV + 0.0 }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.DEC`]="{ item }">
                    <v-chip
                      class="ma-2"
                      :color="item.DEC_COLOR"
                      @click.stop="dialogView = true, getDataShift(item, 12)"
                    >
                      {{ item.DEC + 0.0 }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.totalMonth`]="{ item }">
                    <v-chip
                      class="ma-2"
                      color="amber"
                    >
                      {{ item.JAN + item.FEB + item.MAR + item.APR + item.MAY + item.JUN + item.JUL + item.AUG + item.SEP + item.OCT + item.NOV + item.DEC + 0.0}}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      color="question"
                      fab
                      small
                      @click.stop="dialogView = true, getDataShift(item)"
                    >
                      <v-icon dark> mdi-eye </v-icon>
                    </v-btn>
                  </template>

                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'
// import { gmapApi } from 'vue2-google-maps'
// import moment from 'moment'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  // created () {
  //   setInterval(this.getNowGlobal, 1000)
  // },
  data () {
    return {
      path: '/leave_data/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ลา รวม',
          disabled: false,
          href: '/HRM/Leave/ReportLeave'
        }
      ],
      session: this.$session.getAll(),
      loading: false,
      dialogView: false,
      dataReady: false,
      searchAll: '',
      searchInfoByMonth: '',
      columns: [
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'M1', value: 'JAN' },
        { text: 'M2', value: 'FEB' },
        { text: 'M3', value: 'MAR' },
        { text: 'M4', value: 'APR' },
        { text: 'M5', value: 'MAY' },
        { text: 'M6', value: 'JUN' },
        { text: 'M7', value: 'JUL' },
        { text: 'M7', value: 'AUG' },
        { text: 'M9', value: 'SEP' },
        { text: 'M10', value: 'OCT' },
        { text: 'M11', value: 'NOV' },
        { text: 'M12', value: 'DEC' },
        { text: 'รวม', value: 'totalMonth' },
        { text: 'ดูรายการทั้งหมด', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      columnsSelect: [
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'ประเภท', value: 'quotaLeaveName' },
        { text: 'ตั้งแต่', value: 'leaveStartDate' },
        { text: 'ถึง', value: 'leaveEndDate' },
        { text: 'จำนวน', value: 'leaveSummaryDay' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'หัวหน้า', value: 'empFull_NameTH_header' }
      ],
      dataItemByMonth: [],
      shiftName: '',
      BranchItem: [], // สาขา
      Branch: '', // สาขา
      DepartmentItem: [], // แผนก
      Department: '', // แผนก
      yearsNumber: yearsNumber,
      year: '',
      month: '',
      day: '',
      empCode: '',
      empFull_NameTH: '',
      masBranchName: '',
      masDepartmentName: '',
      masCompanyName: ''
    }
  },
  async mounted () {
    this.year = moment().format('YYYY')
    await this.getGetToken()
    await this.getData()
    await this.getDataBranch()
    await this.getDataDepartment()
  },
  methods: {
    async getData () {
      this.dataReady = false
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            this.path +
            'getDataReportYearAll?year=' +
            this.year,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
          // console.log(this.dataItem)
          this.setColor(this.dataItem)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log(error)
          this.dataReady = true
        })
    },
    setColor (dataItem) {
      dataItem.forEach((element) => {
        console.log(element.JAN)
        element.JAN_COLOR = (element.JAN === null || element.JAN === 0) ? '' : element.JAN > 0 && element.JAN <= 3 ? 'green' : element.JAN > 3 && element.JAN < 10 ? 'red' : 'purple'
        element.FEB_COLOR = (element.FEB === null || element.FEB === 0) ? '' : element.FEB > 0 && element.FEB <= 3 ? 'green' : element.FEB > 3 && element.FEB < 10 ? 'red' : 'purple'
        element.MAR_COLOR = (element.MAR === null || element.MAR === 0) ? '' : element.MAR > 0 && element.MAR <= 3 ? 'green' : element.MAR > 3 && element.MAR < 10 ? 'red' : 'purple'
        element.APR_COLOR = (element.APR === null || element.APR === 0) ? '' : element.APR > 0 && element.APR <= 3 ? 'green' : element.APR > 3 && element.APR < 10 ? 'red' : 'purple'
        element.MAY_COLOR = (element.MAY === null || element.MAY === 0) ? '' : element.MAY > 0 && element.MAY <= 3 ? 'green' : element.MAY > 3 && element.MAY < 10 ? 'red' : 'purple'
        element.JUN_COLOR = (element.JUN === null || element.JUN === 0) ? '' : element.JUN > 0 && element.JUN <= 3 ? 'green' : element.JUN > 3 && element.JUN < 10 ? 'red' : 'purple'
        element.JUL_COLOR = (element.JUL === null || element.JUL === 0) ? '' : element.JUL > 0 && element.JUL <= 3 ? 'green' : element.JUL > 3 && element.JUL < 10 ? 'red' : 'purple'
        element.AUG_COLOR = (element.AUG === null || element.AUG === 0) ? '' : element.AUG > 0 && element.AUG <= 3 ? 'green' : element.AUG > 3 && element.AUG < 10 ? 'red' : 'purple'
        element.SEP_COLOR = (element.SEP === null || element.SEP === 0) ? '' : element.SEP > 0 && element.SEP <= 3 ? 'green' : element.SEP > 3 && element.SEP < 10 ? 'red' : 'purple'
        element.OCT_COLOR = (element.OCT === null || element.OCT === 0) ? '' : element.OCT > 0 && element.OCT <= 3 ? 'green' : element.OCT > 3 && element.OCT < 10 ? 'red' : 'purple'
        element.NOV_COLOR = (element.NOV === null || element.NOV === 0) ? '' : element.NOV > 0 && element.NOV <= 3 ? 'green' : element.NOV > 3 && element.NOV < 10 ? 'red' : 'purple'
        element.DEC_COLOR = (element.DEC === null || element.DEV === 0) ? '' : element.DEC > 0 && element.DEC <= 3 ? 'green' : element.DEC > 3 && element.DEC < 10 ? 'red' : 'purple'
      })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          //  console.log('Company', response.data)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          //  console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          //  console.log('getDataDepartment : ', this.DepartmentItem)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          //  console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    },
    async saerchDataAdvanced () {
      this.dataReady = false
      this.dataItem = []

      var Branch = (this.Branch === '' ? '' : '&masBranchName=' + this.Branch)
      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            this.path +
            'getDataReportYearAll?year=' +
            this.year + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
          // console.log(this.dataItem)
          this.setColor(this.dataItem)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log(error)
          this.dataReady = true
        })
    },
    async clear () {
      this.Branch = ''
      this.Department = ''
      await this.getData()
    },
    async getDataShift (item, month) {
      this.dataItemByMonth = []
      var param = ''
      this.empCode = ''
      this.empFull_NameTH = ''
      this.masBranchName = ''
      this.masDepartmentName = ''
      this.masCompanyName = ''

      param = (month) ? '?empCode=' + item.empCode + '&leaveStartMonth=' + month : '?empCode=' + item.empCode

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'get' + param + '&year(CREATE_DATE)=' + this.year,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log(response.data)
          // this.dataReady = true
          this.dataItemByMonth = response.data
          this.empCode = response.data[0].empCode
          this.empFull_NameTH = response.data[0].empFull_NameTH
          this.masBranchName = response.data[0].masBranchName
          this.masDepartmentName = response.data[0].masDepartmentName
          this.masCompanyName = response.data[0].masCompanyName
          // console.log('desserts', this.desserts)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          // this.dataReady = true
        })
    },
    async exportReport () {
      var dataItme = []
      this.dataItem.forEach((element) => {
        let s = {
          รหัสพนักงาน: element.empCode,
          ชื่อพนักงาน: element.empFull_NameTH,
          แผนก: element.masDepartmentName,
          สาขา: element.masBranchName,
          บริษัท: element.masCompanyName,
          M1: element.JAN,
          M2: element.FEB,
          M3: element.MAR,
          M4: element.APR,
          M5: element.MAY,
          M6: element.JUN,
          M7: element.JUL,
          M8: element.AUG,
          M9: element.SEP,
          M10: element.OCT,
          M11: element.NOV,
          M12: element.DEC,
          รวม: element.JAN + element.FEB + element.MAR + element.APR + element.MAY + element.JUN + element.JUL + element.AUG + element.SEP + element.OCT + element.NOV + element.DEC
        }
        dataItme.push(s)
      })
      var data = XLSX.utils.json_to_sheet(dataItme)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, data, 'รายงาน') // sheetAName is name of Worksheet
      this.month = this.getMonthTh()
      let date = new Date()
      this.year = moment().format('YYYY')
      this.day = date.getDate()
      XLSX.writeFile(wb, 'ลา(' + this.year + ').xls') // name of the file is 'book.xlsx'
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Leave/ReportLeave.vue